import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function ChartMetering({ solorpower, irr, xlabel, chart_style, color }) {
    const indexlabel = '-'
    const xformat = 'HH:mm'
    const tooltip_header = 'Timestamp'
    const tooltip_format = 'DD MMM YYYY HH:mm'
    const plot = [
        { color: color, unit: "kW", name: 'Active Power', dp: 3 },
        { color: "#F1C40F", unit: "W/m2", name: 'Irradiation', dp: 3 }
    ]

    const options = {
        height: 390,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (e.entries[0].dataPoint !== undefined) {
                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">' + tooltip_header + ' : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format(tooltip_format) + '</p>'
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                elem += '<div class="measure-rows font-bold">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp }) + '</div>' +
                                    '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                            }
                        }
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 'normal',
            horizontalAlign: "left"
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 12,
            fontWeight: 'normal',
            cursor: "pointer",
            fontColor: '#000',
            horizontalAlign: "center", // "center" , "right"
            verticalAlign: "top",  // "top" , "bottom"
        },
        axisX: {
            interval: 1,
            intervalType: 'hour',
            labelFormatter: function (e) {
                if (window.screen.width < 576) {
                    const sxs = moment(new Date(e.value)).format(xformat.replaceAll(":mm", "").replaceAll("MMM", "MM"))
                    const nx = Number(sxs - 0)
                    if (nx >= 1 && nx % 3 !== 0) {
                        return ""
                    }
                }
                return moment(new Date(e.value)).format(xformat)
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: 'poppins',
            labelFontSize: 10,
            title: xlabel,
            margin: -5,
            crosshair: {
                enabled: true,
                snapToDataPoint: true,
                color: "orange",
                labelFontColor: "#F8F8F8",
                labelBackgroundColor: "#1A5276",
            },
        },
        axisY: [{
            title: 'Power (kW)',
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "Inter",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "#AEB6BF",
            minimum: 0,
        }],
        axisY2: [{
            title: 'Irradiation (W/m2)',
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "Inter",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "rgba(204, 204, 220, 0.12)",
            minimum: 0,
        }],
        data: [
            {
                type: "area",
                showInLegend: true,
                legendMarkerType: "square",
                name: 'Active Power',
                color: color,
                markerType: "none",
                axisYIndex: 0,
                dataPoints: solorpower,
                fillOpacity: 1,
                lineThickness: 1,
                indexLabelFontSize: 10,
                indexLabelFontWeight: "bold",
                indexLabelFontFamily: 'poppins',
                indexLabelOrientation: indexlabel,
                indexLabelFormatter:
                    function (e) {
                        if (indexlabel !== "-") {
                            if (e.dataPoint.y !== undefined) {
                                return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                            }
                        }
                        return null
                    }
            }, {
                type: "line",
                showInLegend: true,
                name: 'Irradiation',
                axisYType: "secondary",
                color: "#F1C40F",
                markerType: "none",
                axisYIndex: 1,
                dataPoints: irr,
                lineThickness: 2,
            }]
    }

    return (
        <div className="dashboard-chart-wrapper">
            <CanvasJSChart options={options}
            />
        </div>
    );
}
